import styles from './FJGenerating.module.less';
import classNames from 'classnames';
import startBase64 from '../../../assets/base64/star.js';
import FJLocalStore from '../../../store/FJLocalStore.js';

const FJGenerating = props => {
    const { className = '', style = {} } = props;
    return (
        <div
            className={classNames(styles.box, className)}
            style={style}
            onClick={e => {
                // e.stopPropagation();
            }}
        >
            <div className={styles.temp_box} style={style}>
                <img className={styles.img} src={startBase64} alt='' />
                <div className={styles.title}>{FJLocalStore._('generating_')}</div>
            </div>
        </div>
    );
};

export default FJGenerating;
